import { useQuery } from '@tanstack/react-query'

import { GetPlpBannerViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

import { PLPPageProps } from '../types'

export function useGetPLPBanner({ searchParams }: PLPPageProps) {
    const { cat_id, tag_id } = searchParams || {}

    return useQuery<unknown, unknown, GetPlpBannerViewModel>({
        queryKey: QueryKeys.PLP.PLPBanner(cat_id, tag_id),
        queryFn: () => {
            const requestParams = new URLSearchParams(cat_id ? `cat_id=${cat_id}` : `tag_id=${tag_id}`)

            return fetchRequest({
                endpoint: `/plp-banners?${requestParams}`,
                method: 'GET',
                serviceName: 'cml',
            })
        },
        enabled: !!cat_id || !!tag_id,
    })
}
